module.exports = __webpack_public_path__ + "static/media/hackathon2.45224d44.png";